export default __webpack_public_path__ + "static/media/JPG輪播1-7.fb75c7b9.jpg";